import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import AppInfoView from '@crema/core/AppInfoView';
import {Box, Slide, Zoom} from '@mui/material';
import Hidden from '@mui/material/Hidden';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';

import {onToggleAppDrawer} from 'redux/actions';
import AppSidebar from './AppSidebar';
import {useLayoutContext} from '../../utility/AppContextProvider/LayoutContextProvider';
import {Fonts} from 'shared/constants/AppEnums';
import AppContainerWrapper from './AppContainerWrapper';

const AppsContainer = (props) => {
  const dispatch = useDispatch();
  const isAppDrawerOpen = useSelector(({common}) => common.isAppDrawerOpen);
  const {footer} = useLayoutContext();
  const {navStyle} = useLayoutContext();
  const {title, sidebarContent, fullView, children,isDash} = props;

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        margin: -4,
        padding: 2,
        ...props.sxStyle,
      }}
    >
      <Box
        sx={{
          marginTop: fullView ? 0 : -4,
          display: 'flex',
          alignItems: 'center',
          mb: {
            xs: fullView ? 2 : 2,
            lg: 2,
          },
          mt: {
            xs: fullView ? 0 : -4,
            lg: 0,
          },
        }}
      >
        {fullView ? null : (
          <Hidden lgUp>
            <IconButton
              edge='start'
              sx={{
                marginRight: (theme) => theme.spacing(2),
              }}
              color='inherit'
              aria-label='open drawer'
              onClick={() => dispatch(onToggleAppDrawer())}
              size='large'
            >
              <MenuIcon
                sx={{
                  width: 35,
                  height: 35,
                }}
              />
            </IconButton>
          </Hidden>
        )}
        {/* <Zoom in style={{transitionDelay: '300ms'}}> */}
          <Box
            component='h2'
            variant='h2'
            sx={{
              fontSize: 16,
              color: 'text.primary',
              fontWeight: Fonts.SEMI_BOLD,
              width:'100%'
            }}
          >
            {title}
          </Box>
        {/* </Zoom> */}
      </Box>

      <AppContainerWrapper isDash={isDash} navStyle={navStyle} footer={footer}>
        {sidebarContent ? (
          <AppSidebar
            isAppDrawerOpen={isAppDrawerOpen}
            footer={footer}
            fullView={fullView}
            navStyle={navStyle}
            sidebarContent={sidebarContent}
          />
        ) : null}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: {
              xs: '100%',
              lg: `calc(100% - ${fullView ? 0 : 280}px)`,
            },
            pl: {
              lg: props.fullView ? 0 : 8,
            },
          }}
        >
          <Slide direction='left' in mountOnEnter unmountOnExit>
            <Card
              style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                ...props.cardStyle,
              }}
            >
              {children}
            </Card>
          </Slide>
          <AppInfoView />
        </Box>
      </AppContainerWrapper>
    </Box>
  );
};

export default AppsContainer;

AppsContainer.defaultProps = {
  title: '',
};

AppsContainer.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  sidebarContent: PropTypes.node,
  fullView: PropTypes.bool,
  children: PropTypes.node,
  sxStyle: PropTypes.object,
  cardStyle: PropTypes.object,
  isDash:PropTypes.bool,
};
